import type { QuickLauncherDestination } from "./destination.types";

export type DestinationRow = Omit<
  QuickLauncherDestination,
  "section" | "trail"
> & { trail?: string[] };

/** Stamps a table's rows with its section; a row with no trail sits directly under it. */
export default function inSection(
  section: string,
  rows: DestinationRow[]
): QuickLauncherDestination[] {
  return rows.map(({ trail, ...row }) => ({
    section,
    trail: trail ?? [],
    ...row
  }));
}
